export class RowValue {
  value: string;
  idColumn: string;
}
